export const CONVERSATION_API = {
    getStudentList: (userId: string) => `/v1/admin/conversation/${userId}`,
    getUnresolvedChat: (userId: string) => `/v1/admin/conversation/${userId}`,
    getChat: (conversationId) =>
        `/v1/admin/conversation/${conversationId}/chat`,
    sendMessage: (conversationId) =>
        `/v1/admin/conversation/${conversationId}/chat`,
    addProfaneWords: (conversationId) =>
        `/v1/admin/conversation/${conversationId}/block-words`,
    getConversationDetails: (conversationId) =>
        `/v1/admin/conversation/${conversationId}/room-info`,
    joinConversation: (conversationId) =>
        `/v1/admin/conversation/${conversationId}/join-conversation`,
    closeConversation: (conversationId) =>
        `/v1/admin/conversation/${conversationId}/close-room`,
    conversationBlockMember: (conversationId, userId) =>
        `/v1/admin/conversation/${conversationId}/user-chat-access/${userId}`,
    deleteChat: (conversationId, chatId) =>
        `/v1/admin/conversation/${conversationId}/chat/${chatId}`,
    getUnReadMessage: (conversationId, userId) =>
        `/v1/admin/conversation/${conversationId}/chat/${userId}/unread-messages`,
    updateEmojiTemplates: (typeId) => `/v1/admin/conversation/emoji/${typeId}`,
    getEmojiTemplates: (typeId) =>
        `/v1/admin/conversation/emoji/${typeId}?isAdminEmoji=true`,
};
